import ar from "./ar.json";
import en from "./en.json";

export const language = () => {
    switch (localStorage.getItem("language")) {
        case "ar":
            return ar;
        case "en":
            return en;
        default:
            return ar;
    }
}

// const wordList = language(); 